import React from "react";
import { motion } from "framer-motion";
import { GAME_THEME } from "../lib/api";

export const GameSwitcher = ({ game, setGame }) => {
  const games = ["mega_millions", "powerball"];
  return (
    <div
      className="inline-flex items-center rounded-full p-1 bg-zinc-900 border border-zinc-800"
      data-testid="game-switcher"
    >
      {games.map((g) => {
        const active = g === game;
        const t = GAME_THEME[g];
        return (
          <button
            key={g}
            onClick={() => setGame(g)}
            data-testid={`game-switcher-${g === "mega_millions" ? "mega" : "power"}`}
            className="relative px-5 sm:px-8 py-2.5 rounded-full text-sm font-semibold transition-colors duration-200"
            style={{ color: active ? "#09090b" : "#a1a1aa" }}
          >
            {active && (
              <motion.div
                layoutId="game-pill"
                className="absolute inset-0 rounded-full"
                style={{ backgroundColor: t.color }}
                transition={{ type: "spring", stiffness: 380, damping: 32 }}
              />
            )}
            <span className="relative z-10 whitespace-nowrap font-heading">{t.name}</span>
          </button>
        );
      })}
    </div>
  );
};
